'use strict';

module.exports = require('./browser/algorithms.json');



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 1066
// module chunks = 44